import React from "react";
import MyRouter from "routers/index";
import * as firebase from "firebase/app";

function App() {
  const fbConfig = {
    apiKey: "AIzaSyBmGw1Fy1kvEINuTcFp8KdajzvvwVEBgHA",
    authDomain: "guidesantai-5a3a7.firebaseapp.com",
    // authDomain: "guidesantai.com",
    projectId: "guidesantai-5a3a7",
    storageBucket: "guidesantai-5a3a7.appspot.com",
    messagingSenderId: "837959303658",
    appId: "1:837959303658:web:58e51dcd6a924fc9edf293",
    measurementId: "G-QDEHVNB46C"
  };
  firebase.initializeApp(fbConfig)
  
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;
